import { NotificationEventType } from "@/types/notificationTypes";

export const NOTIFICATION_EVENTS: Record<NotificationEventType, string> = {
  shown: "notification_shown",
  snoozed: "notification_snoozed",
  acknowledged: "notification_acknowledged",
  dismissed: "notification_dismissed",
  action_clicked: "notification_action_clicked",
};

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (import.meta.env.MODE === "development") {
    console.debug("[tracking]", name, params ?? {});
  }
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  try {
    window.gtag("event", name, params ?? {});
  } catch {}
}

export function trackPageView(path: string): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  trackEvent("page_view", {
    page_path: path,
    page_location: (window.location?.origin ?? "") + path,
    page_title: typeof document === "undefined" ? "" : document.title,
  });
}
